import type { DiscoveredRouteModule } from '@/router/generator/types';

const UpgradeRequiredView = () => import('@/views/error-pages/UpgradeRequiredView.vue');
export const NAME_UPGRADE_REQUIRED = 'UpgradeRequired';
export const PATH_UPGRADE_REQUIRED = '/upgrade-required';

export const route: DiscoveredRouteModule = {
  id: 'root.error.upgrade_required',
  scope: 'root',
  name: NAME_UPGRADE_REQUIRED,
  path: PATH_UPGRADE_REQUIRED,
  component: UpgradeRequiredView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


